import { ResourceType } from '../../shared/resource-type';

/**
 * The resource type for ItemExportFormat
 *
 * Needs to be in a separate file to prevent circular
 * dependencies in webpack.
 */
export const ITEM_EXPORT_FORMAT = new ResourceType('itemexportformat');
